import { Button } from '@mui/material';
import Grid from 'components/core/Grid';
import styled from 'styled-components';

export const CodeFormWrapper = styled(Grid)`
  width: 240px;
  position: relative;

  & .MuiInputBase-root {
    letter-spacing: 24px;
    caret-color: transparent;
    font-weight: bold;
    padding-left: ${props => props.theme.spacing(3.5)}px;
    padding-right: 0px;
  }

  & .Mui-focused {
  }

  & .input-separator {
    border-right: 1px solid ${props => props.theme.palette.grey[300]};
    width: 1px;
    height: 20px;
    position: absolute;
    top: 41%;

    &:nth-of-type(1) {
      left: ${props => props.theme.spacing(7)}px;
    }

    &:nth-of-type(2) {
      left: ${props => props.theme.spacing(11)}px;
    }

    &:nth-of-type(3) {
      left: ${props => props.theme.spacing(15)}px;
    }

    &:nth-of-type(4) {
      left: ${props => props.theme.spacing(19)}px;
    }

    &:nth-of-type(5) {
      left: ${props => props.theme.spacing(23)}px;
    }
  }
`;

export const ButtonWrapper = styled(Grid)`
  display: flex;
  justify-content: space-evenly;
`;

export const VerificationGrid = styled(Grid)`
  display: flex;
  text-align: center;
  justify-content: center;

  & img {
    width: 100px;
  }
`;

export const NotVerifiedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const NotVerifiedButton = styled(Button)`
  border: 1px solid ${props => props.theme.palette.error.main};
  background-color: ${props => props.theme.palette.error.main};
  color: #fff;
  flex: 1;

  & svg {
    color: #fff;
  }

  &:hover {
    filter: brightness(110%);
    background-color: ${props => props.theme.palette.error.main};
  }
`;

export const VerifiedButton = styled(Button)`
  border: 1px solid ${props => props.theme.palette.grey[400]};
  color: ${props => props.theme.palette.secondary.main};
  & svg {
    color: ${props => props.theme.palette.success.main};
  }
`;
